import axios from 'axios';
import queryString from 'query-string';

window.clickStarted = false;
window.clickAddthisStarted = false;

export default class Click {
  init($) {
    if (window.clickStarted) {
      return;
    }
    window.clickStarted = true;

    if (window.entityId && window.entityType) {
      $('.mtm').find('a').each(function () {
        const self = $(this);
        self.attr('data-click-type', 'site-link');
        self.attr('data-entity-id', window.entityId);
        self.attr('data-entity-type', window.entityType);
        const href = self.attr('href');
        if (href !== undefined && href.indexOf('#') === -1) {
          self.attr('target', '_blank');
        }
        self.addClass('track_website_click');
      });
    }

    const websiteSelector = $('.track_website_click');

    websiteSelector.on('click', (e) => {
      const el = $(e.currentTarget);
      this.constructor.track(
        el.data('click-type'),
        el.data('entity-id'),
        el.data('entity-type'),
        window.location.href,
        el.attr('href')
      );
    });

    if (window.addthis && !window.clickAddthisStarted) {
      window.addthis.addEventListener('addthis.menu.share', addthisCallbackOnShare);
      window.clickAddthisStarted = true;
    }
  }

  static track(clickType, entityId, entityType, originUrl, targetUrl) {
    const api = axios.create({
      baseURL: process.env.NODE_ENV === 'test' ? 'http://ntp.test/' : '/'
    });
    return api.post('/system/ajax_handlers/click.php', queryString.stringify({
      entity_id: entityId,
      entity_type: entityType,
      click_type: clickType,
      origin_url: originUrl,
      target_url: targetUrl
    })
    );
  }
}

function addthisCallbackOnShare(e) {
  Click.track(e.data.service, window.entityId, window.entityType, window.location.href, '');
}



// WEBPACK FOOTER //
// ./_common/scripts/click.js